export default __webpack_public_path__ + "static/media/StartCreating-poster.e02b3175.jpg";